export default __webpack_public_path__ + "static/media/box.b6fa5846.svg";